/* global window */
'use strict';

module.exports = {
    hasPremium: function () {
        // NOTE WELL: There is a CSS class is-ad-free applied to the body element
        // when window.TempestIdentity.benefits.premiumExperience is set, by
        // code included directly in the HTML template. If the logic here
        // changes then the logic in the HTML probably ought to change too.
        return !!(window.TempestIdentity && window.TempestIdentity.benefits.premiumExperience);
    },
};
